import React from 'react'
import LiquidBlock from '../blocks/LiquidBlock'
import '../styles/Tickets.css'
import { useEffect } from 'react'
import { useState } from 'react'
import API from '../APIs/MainAPI'
import QRCode from "react-qr-code";
import LiquidButton from '../blocks/LiquidButton'
import LiquidBlockTop from '../blocks/LiquidBlockTop'
import LiquidRoundButton from '../blocks/LiquidRoundButton'
import { useNavigate } from 'react-router-dom'
import Page from '../blocks/Page'

const Tickets = ({userData}) => {

  const navigate = useNavigate()

  const [events, setEvents] = useState([])
  const [isCancelMemb, setIsCancelMemb] = useState(false)
  const [selectedEvId, setSelectedEvId] = useState(null)

  const [currentMemb, setCurrentMemb] = useState(null)

  useEffect(() => {
    if(events.length == 0){
      API.LoadEvents().then((data) => {
        console.log(data.res);
        setEvents(data.res.data)
      })
    }
  }, [])

  const handleCancelMemb = () => {
    const eventData = {
      _id: selectedEvId
    }
    API.CancelMembership(eventData, userData).then((data) => {
      if(data.status == 200){
        navigate('/')
        window.location.reload()
      }
    }).catch(e => console.error(e))
  }

  return (<>
    {isCancelMemb ? 
      <LiquidBlockTop>
        <LiquidRoundButton onClick={() => {
          setSelectedEvId(null)
          setIsCancelMemb(false)
          }}>←</LiquidRoundButton>
          <h2 className='dangCancelTxt'>Вы точно хотите отменить участие?</h2>
          <LiquidButton onClick={() => handleCancelMemb()}>Отменить</LiquidButton>
      </LiquidBlockTop>
    : null}
    <section className='ticketsSection'>
      <h2 className='ticketsText'>Тикеты</h2>
      <div className="tickets">
        {(() => {
          const filteredEvents = events?.filter(event => 
            (event?.status != 'eventClosed') && userData?.events?.includes(event._id)
          );
          
          if (!filteredEvents || filteredEvents.length === 0) {
            return <h4>Тикетов нет</h4>;
          }
          
          return filteredEvents.map(event => (
            <LiquidBlock key={event?._id}>
              <div className="textEventData">
                <h2>{event?.name}</h2>
                <p>{event?.date} | {event?.time}</p>
                <div className="qrCont">
                  <LiquidBlock>
                    <div className="qrCodeCent">
                      <QRCode 
                      className='qrCodeImg'
                        value={`${event._id} | ${userData._id}`} 
                        size={256} 
                        bgColor='#ffffff' 
                        fgColor='#000000'/>
                    </div>
                    <div className="underQrData">
                      {(() => {
                        const currentMember = event?.members?.find(member => member.usMongoID === userData._id);
                        
                        return currentMember ? (
                            <div className="member-info">
                              <span>{currentMember.firstName} {currentMember.secondName} {currentMember.thirdName}</span>
                              {currentMember.isGrad ? 
                              <span className="graduate-badge">Выпускник</span> : 
                              <span>Класс: {currentMember.gradeNum} {currentMember.gradeLetter}</span>}
                              {currentMember.ticketStatus != 'notCome' ? <span className="usedTicketStatus">Использованный</span> : 
                              <span className="notUsedTicketStatus">Неиспользованный</span>
                              }
                            </div>
                        ) : null
                      })()}
                    </div>
                  </LiquidBlock>
                  {(() => {
                    let member = event?.members?.find(member => member.usMongoID === userData._id)
                    return member ? (
                      member?.ticketStatus== 'notCome' ? <LiquidButton onClick={() => {
                      setIsCancelMemb(true)
                      setSelectedEvId(event._id)
                      }}>Отменить участие</LiquidButton> : null
                    ) : null
                  })()}
                </div>
              </div>
            </LiquidBlock>
          ));
        })()}
      </div>
      {/* <LiquidBlock>
        <h2>В разработке, но скоро будет</h2>
      </LiquidBlock> */}
    </section>
    </>
  )
}

export default Tickets